import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConfirmationProvider } from './features/confirmation/ConfirmationProvider.js';
import { initPwaLifecycle } from './pwa/lifecycle.js';
import { router } from './router.js';
import { initTheme } from './stores/ui.js';
import './styles.css';

initTheme();
initPwaLifecycle();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmationProvider>
        <RouterProvider router={router} />
      </ConfirmationProvider>
    </QueryClientProvider>
  </StrictMode>,
);
